import { localStorage } from "@prismicio/editor-support/DOM"
import { Box, Button, Icon, Text } from "@prismicio/editor-ui"
import { useState } from "react"

import { newMediaLibraryFeaturesBannerClosed } from "../../../constants/localStorage"

interface NewMediaLibraryFeaturesBannerProps {
  maxWidth?: number
}

export function NewMediaLibraryFeaturesBanner(
  props: NewMediaLibraryFeaturesBannerProps
) {
  const { maxWidth } = props

  const [open, setOpen] = useState(() => {
    if (
      localStorage.isAvailable() &&
      localStorage.read(newMediaLibraryFeaturesBannerClosed)
    ) {
      return false
    }
    return true
  })

  function onClose() {
    setOpen(false)
    if (localStorage.isAvailable()) {
      localStorage.write(
        newMediaLibraryFeaturesBannerClosed,
        String(Date.now())
      )
    }
  }

  if (!open) {
    return null
  }

  return (
    <Box
      justifyContent="center"
      padding={{ inline: 16, block: 12 }}
      backgroundColor="purple9"
    >
      <Box maxWidth={maxWidth} width="100%" alignItems="center" gap={8}>
        <Box
          borderRadius="100%"
          alignItems="center"
          justifyContent="center"
          width={28}
          height={28}
          border
          borderColor="purple8"
          flexShrink={0}
        >
          <Icon name="autoFixHigh" color="white" size="small" />
        </Box>
        <div>
          <Text color="white" variant="bold">
            New features on the Media Library coming soon!
          </Text>
          <Box gap={4} flexWrap="wrap">
            <Text color="white">
              Media Tagging, Filtering, Improved Search & Bulk Deletion
            </Text>
            <Text
              color="white"
              variant="bold"
              href="https://prismic.io/lp/new-media-library"
              target="_blank"
              rel="noopener noreferrer"
              underline
            >
              Get notified →
            </Text>
          </Box>
        </div>
        <Button
          invisible
          color="white"
          sx={{ marginLeft: "auto", marginBottom: "auto", flexShrink: 0 }}
          underline
          onClick={onClose}
        >
          Close
        </Button>
      </Box>
    </Box>
  )
}
